import { Button, Popconfirm, Tooltip } from 'antd';
import type { UserListItem } from './users.api';

interface UserRowActionsProps {
  user: UserListItem;
  /** Your own row: the server refuses self-deactivation, so the button explains why rather than failing. Resetting your own password has no such restriction. */
  isYou: boolean;
  onResetPassword: (user: UserListItem) => void;
  onDeactivate: (user: UserListItem) => Promise<void>;
  onReactivate: (user: UserListItem) => Promise<void>;
}

/** Deactivation is immediate and affects someone else's account, so it asks first — same weight CLAUDE.md gives closing out a trip. */
export function UserRowActions({ user, isYou, onResetPassword, onDeactivate, onReactivate }: UserRowActionsProps) {
  const resetPasswordButton = (
    <Button size="small" onClick={() => onResetPassword(user)}>
      Reset password
    </Button>
  );

  if (isYou) {
    return (
      <span className="inline-flex gap-2">
        {resetPasswordButton}
        <Tooltip title="You can't deactivate your own account">
          <Button danger size="small" disabled>
            Deactivate
          </Button>
        </Tooltip>
      </span>
    );
  }

  return (
    <span className="inline-flex gap-2">
      {resetPasswordButton}
      {user.isActive ? (
        <Popconfirm title={`Deactivate ${user.name}?`} description="They are signed out everywhere immediately." onConfirm={() => onDeactivate(user)}>
          <Button danger size="small">
            Deactivate
          </Button>
        </Popconfirm>
      ) : (
        <Popconfirm title={`Reactivate ${user.name}?`} onConfirm={() => onReactivate(user)}>
          <Button size="small">Reactivate</Button>
        </Popconfirm>
      )}
    </span>
  );
}
